import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useScreenShare, useDailyEvent } from '@daily-co/daily-react';
import { Screenshare, ScreenshareOn, ReactionButton } from './Icons';
import { pageAtom } from '../../State';
import { useRecoilState, useSetRecoilState } from 'recoil';
import './Tray.css';
import isElectron from '../../Global';
import { useTranslation } from 'react-i18next';
export default function TrayScreenShare() {
  //Daily系
  const { screens, startScreenShare, stopScreenShare } = useScreenShare(); //スクリーンシェア
  const setPageState = useSetRecoilState(pageAtom);
  const { t } = useTranslation();
  //スクリーンシェアでエラーが起きた場合
  // useDailyEvent(
  //   'screen-share-error',
  //   useCallback((ev) => {
  //     console.log('ここよばれてる');
  //     console.log(ev);
  //   }, []),
  // );

  useDailyEvent('nonfatal-error', (ev) => {
    if (ev.type == 'screen-share-error') {
      //ブラウザ側が未許可
      if (ev.errorMsg == 'Error starting ScreenShare: blocked-by-browser') {
      }
      //OS側が未許可
      else {
        alert(
          t(
            'call.Your OS is blocking screen share. Please check system setting → Privacy/Security → Activate screen share / recording',
          ),
        );
      }
    }
  });

  //スクリーンシェアボタン押した時
  const toggleScreenShare = async () => {
    if (screens.length > 0) {
      //自分のスクリーンの場合
      if (screens[0].local) {
        stopScreenShare();
      }
      //他の人のスクリーンの場合
      else {
        alert(t('call.Another participant is sharing screen now'));
      }
    } else {
      if (isElectron) {
        startScreenShareElectron();
      } else {
        // try {
        //   let dd = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
        //   console.log(dd);
        // } catch (err) {
        //   console.error('Error: ' + err);
        // }

        try {
          startScreenShare({
            audio: true,
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  };

  async function startScreenShareElectron() {
    // const sources = await window.myapi.startShare('https://faceless.ooo/login');

    setPageState('selectScreen');

    // const image = sources[0].thumbnail.toDataURL();

    // console.log(image);
    // let mediaStream = await navigator.mediaDevices.getUserMedia({
    //   video: {
    //     mandatory: {
    //       chromeMediaSource: 'window',
    //     },
    //   },
    // });
    // callObject.startScreenShare({ mediaStream });
    // const { desktopCapturer } = require('electron');
    // desktopCapturer
    //   .getSources({
    //     types: ['window', 'screen'],
    //   })
    //   .then(async (sources) => {
    //     for (const source of sources) {
    //       if (source.name === 'Chrome') {
    //         mediaStream = await navigator.mediaDevices.getUserMedia({
    //           video: {
    //             mandatory: {
    //               chromeMediaSource: 'desktop',
    //               chromeMediaSourceId: source.id,
    //             },
    //           },
    //         });
    //         return;
    //       }
    //     }
    //   });
    // callObject.startScreenShare({ mediaStream });
  }

  //レンダー
  return (
    <button onClick={toggleScreenShare}>
      {screens.length > 0 && screens[0].local ? <ScreenshareOn /> : <Screenshare />}
    </button>
  );
}
